import { IEmployee } from "../views/settings/types/employee"

/**
 * Return employee full name name as initials
 * @param emp
 * @return string - employee-initials
 */

export const createInitials = (emp : IEmployee) => {
    let _initials = ''
    if (emp.first_name?.length > 0) {
      _initials = emp.first_name[0].toLocaleUpperCase()
    }
    if (emp.last_name?.length > 0) {
      _initials += emp.last_name[0].toLocaleUpperCase()
    }
    if (_initials == '' && 'full_name' in emp && emp.full_name !== '') {
      const parts = emp.full_name.split(' ').filter(Boolean)
      _initials = parts[0][0].toLocaleUpperCase() + parts[1][0].toLocaleUpperCase() 
    }
    return _initials
  }